import { css, cx } from "@emotion/css";
import { useTranslation } from "react-i18next";

import { useTheme } from "@/modules/theme/hooks/useTheme";
import { grey } from "@/modules/theme/utils/colors";
import { Theme } from "@/modules/theme/utils/createTheme";

import { NonBreakingSpace } from "../NonBreakingSpace";

type DeadlineProps = {
  children: React.ReactNode;
  variant?: "light" | "dark";
};

const translationNamespace = "layouts/AuthenticatedLayout/components/Deadline";

export const Deadline: React.FC<DeadlineProps> = ({
  children,
  variant = "light",
}) => {
  const { t } = useTranslation(translationNamespace);
  const classes = createDeadlineStyles(useTheme());
  return (
    <p
      className={cx(classes.root, {
        [classes.dark]: variant === "dark",
      })}
    >
      <span className={cx(classes.deadlinePrefix, classes[variant])}>
        {t("Deadline")}:<NonBreakingSpace />
      </span>
      {children}
    </p>
  );
};

function createDeadlineStyles({ typography, palette, spacing }: Theme) {
  return {
    root: css({
      display: "flex",
      whiteSpace: "nowrap",
      fontSize: typography.fontSize.default,
      fontWeight: typography.fontWeight.semiBold,
      lineHeight: "normal",
      color: palette.secondary.text,
      marginRight: spacing(1),
    }),
    deadlinePrefix: css({
      fontWeight: typography.fontWeight.medium,
    }),
    light: css({
      color: grey[600],
    }),
    dark: css({
      color: palette.secondary.textDark,
    }),
  };
}
